// Library Class
import { Component, OnInit, ViewChild, AfterViewInit, HostListener, ElementRef, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';
// Service Class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { BroadcastService } from '../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../../services/infrastructure/config.service';
import { SeedReturnService } from '../../../../services/seed/seed-return.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { SeedReturnAddProductSliderModelService } from './../../../../common/components/seed-return-add-product/seed-return-product-slider-model.service';

// Class
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { ReturnPeriodSecurityList } from '../../../../models/SeedReturn/ReturnPeriodSecurityList';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { CommonService } from '../../../../services/common/common.service';

@Component({
  selector: 'app-seed-returns-soybean-create-edit',
  templateUrl: './seed-returns-soybean-create-edit.component.html',
  styleUrls: ['./seed-returns-soybean-create-edit.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: 0, display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class SeedReturnsSoybeanCreateEditComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('productTable', { read: MatSort }) productSort: MatSort;
  @ViewChild('uploader') scaleTicket: ElementRef;
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  nextErrorId = 0;
  nextLotNumber: string;
  // Header selected values
  shipToAccount: number;
  shipToAccountName: number;
  shipToAccountItems: any[];
  headerCompany = MasterConstants.US_COMPANYCODE;
  cropYear: any;
  dashboardFilter: DashboardFilter;
  originalProductItemsDataSource: any;
  searchValue = '';
  partialSearchValue = '';
  lotNumberList: any = [];
  invoicedProductList: any = [];
  invoiceNumberList: any = [];
  productAllDataSource: any;
  scaleTicketDataSource: any;
  scaleTicketList: any = [];
  displayedColumns: string[] = ['checkbox', 'product', 'lotNumber', 'uom', 'units', 'dumpedUnits', 'notes'];
  displayedScaleColumns: string[] = ['checkbox', 'scalesTicketName', 'uploaded', 'fileType', 'viewFile'];
  allTicketChecked = false;
  isSaveOrderDraftEnable = false;
  isPlaceOrderEnable = false;
  isAddProductEnable = false;
  isScaleTicketEnable = false;
  showTabs = false;
  showScaleTabs = false;
  tabNode: string;
  editToolKit = false;
  isParent = false;
  lineStatus: any = '';
  requestOnBehalfList: any = [];
  requestedByUser: string;
  currentRequestedUser: string;
  statusList: any = [{ 'id': 'APPROVED', 'value': 'APPROVED' },
  { 'id': 'ERROR', 'value': 'ERROR' },
  { 'id': 'PENDING', 'value': 'PENDING' },
  { 'id': 'REJECTED', 'value': 'REJECTED' }];
  // Search Type set Up fro grid
  searchTypeList: any = [
    { name: 'Product Name', value: 'productName' },
    { name: 'Marketing Brand', value: 'marketingBrand' },
    { name: 'Package Size', value: 'packageSize' },
    { name: 'Technology', value: 'technology' },
    { name: 'Treatment', value: 'treatmentDescription' },
    { name: 'Item Number', value: 'itemNumber' },
    { name: 'Invoice Number', value: 'invoiceNumber' },
    { name: 'Lot Number', value: 'lotNumber' }
  ];
  shipToDataLoading = true;
  disablecheckbox: any;
  disableScaleCheckbox: any;
  selectedCount = 0;
  checkBoxCount = 0;
  selectedTicketCount = 0;
  selectedAccountName: any = '';
  isSearchClicked: any;
  index: any;
  enable: any;
  returnRequestNumber = 0;
  returnRequestId = 0;
  isEditMode = false;
  dataChangeSubscription: any;
  hasChangeAdded = false;
  dateFilter: any;
  sub: Subscription;
  filteredDataCount = 0;
  qtyCount = 0;
  totalPrice = 0;
  isNotValid = false;
  accountEmail: string;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  individualEmailPattern: any = MasterConstants.INDIVIDUAL_EMAIL_PATTERN;
  // readOnlyAccess: boolean = false;
  reviewRequestMode = false;
  userMenuAccessList: any;
  date = new Date();
  maxDate = new Date(this.date.setMonth(this.date.getMonth() + 6));
  dsmInfo: string;
  dsmId = 0;
  filterValueList: any = [];
  productFilters: any;
  productList: any[];
  productSearchFilter: string;
  filterInvoicedProductitems: any[] = [];
  isAllProductChecked = false;
  userIdRole: string;
  isApprovalAccess = false;
  createRequestAccess = false;
  editApprovalList: any = {};
  roleType: string;
  enableCreate = true;
  requestStatus: string;
  isValidLineStatus = false;

  showSubmitToJde = false;
  showSubmitReturn = false;
  breadcrumbtext: string;
  showScaleDelete = false;
  marketingBrandMasterList: any[];
  packageSizeMasterList: any = [];
  treatmentMasterList: any[];
  technologyMasterList: any[];
  showDelete = false;
  onBehalfUser: any;
  selectedUserName: string;
  scaleTicketTooltip: string;
  isRequestPending = true;
  validateEvolveData: any;
  disableRejectedLine = true;
  isIncreaseQtyEnable = true;
  isDecreaseQtyEnable = true;
  returnPeriodSecurity: ReturnPeriodSecurityList;
  seedReturnProductListOriginalData: any[];
  oldEmail: string;
  leaveWithoutSavingYesButtonText = 'Discard changes and submit request'; // 'Yes';
  leaveWithoutSavingNoButtonText = 'No, go back to Request';
  isInEditActionHasRun = false;
  subscription = new Subscription();
  isShowNonSubEmail = true;
  isAutoApprove: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private calendar: NgbCalendar,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private toastrService: ToastrService,
    private seedReturnService: SeedReturnService,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private datePipe: DatePipe,
    private seedReturnAddProductSliderModelService: SeedReturnAddProductSliderModelService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();

    this.subscription.add(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
  }

  ngOnInit() {
    this.seedReturnService.setSelectedProductLine(MasterConstants.PRODUCT_LINE_SOYBEAN);
    this.requestStatus = this.seedReturnService.returnRequestStatus;

    if (this.requestStatus === 'IN EDIT') {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldReturnQty: 1, newReturnQty: 0, labelNo: this.leaveWithoutSavingNoButtonText, inEdit: this.requestStatus === 'IN EDIT', labelYes: this.leaveWithoutSavingYesButtonText });
    }

    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.cropYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isShowNonSubEmail = false;
        } else {
          this.isShowNonSubEmail = true;
        }
        this.userIdRole = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userIdRole;
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
          //this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.RETURN_REQUEST_INVENTORY_PROTECTION, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList) || this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.RETURN_REQUEST_IP_APPROVAL, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.isApprovalAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.RETURN_REQUEST_IP_APPROVAL);
          this.createRequestAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.RETURN_REQUEST_INVENTORY_PROTECTION);

          this.roleType = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).roleType.toUpperCase();
          // Get Return Request Id from URL
          this.subscription.add(this.activatedRoute.params.subscribe(x => {
            this.errorMsgs = [];
            if (x['returnRequestId']) {
              this.returnRequestId = +x['returnRequestId'];
              this.isEditMode = true;
              this.editButtonStatus();
              this.getOrderDetails();
              this.searchTypeList = [
                { name: 'Product Name', value: 'productName' },
                { name: 'Marketing Brand', value: 'marketingBrand' },
                { name: 'Package Size', value: 'packageSize' },
                { name: 'Technology', value: 'technology' },
                { name: 'Treatment', value: 'treatmentDescription' },
                { name: 'Item Number', value: 'itemNumber' },
                { name: 'Invoice Number', value: 'invoiceNumber' },
                { name: 'Lot Number', value: 'lotNumber' },
                { name: 'Status', value: 'status' }
              ];
            } else {
              this.enableCreate = true;
              this.loadMasterData();
            }
          }));
        }
        this.enableCreate = true;
      }
    }
    this.resetProductFilter();
    this.hasChangeAdded = false;
    this.productAllDataSource = new MatTableDataSource([]);
    this.scaleTicketDataSource = new MatTableDataSource([]);
    this.disablecheckbox = true;
    this.disableScaleCheckbox = true;
    this.getAccountList();
    this.seedReturnService.setEditModeStatus(false);
    this.enableFiltersAndButtonAsPermission();
    this.subscription.add(this.seedReturnAddProductSliderModelService.seedReturnModelData.subscribe(selectedProductList => {
      if (selectedProductList.length > 0) {
        this.disablecheckbox = false;
        this.disableScaleCheckbox = false;
        this.editToolKit = false;
        this.showTabs = false;
        this.showErrorBlock = false;
        this.errorMsgs = [];
        this.isEditMode = this.seedReturnService.getEditModeStatus();
        this.originalProductItemsDataSource = this.productAllDataSource.data;
        const orderList = [];
        let rowId = 0;
        this.productAllDataSource.data.forEach(x => {
          orderList.push(x);
          if (x.rowId > rowId) { rowId = x.rowId; }
        });
        let productAdded = true;
        selectedProductList.forEach(item => {
          const duplicateData = orderList.find(y => y.itemId == item.itemId && y.lotNumber == item.lotNumber);
          item.lineErrors = { 'itemId': item.itemId, 'lotNumber': item.lotNumber, 'errors': [] };
          item.lineError = false;

          if (duplicateData == undefined) {
            item.returnRequestItemId = 0;
            item.returnQuantity = 0;
            item.eligibleUnit = item.isManualLine ? 0 : item.eligibleUnit ? item.eligibleUnit : (item.invoiceUnits - item.totalReturnUnits) > 0 ? (item.invoiceUnits - item.totalReturnUnits) : 0;
            orderList.push(item);
            if (productAdded) {
              this.toastrService.info('Product Added');
              productAdded = false;
            }
          } else {// Addition use case implemented asked in bug 74741
            if (duplicateData.isManualLine && !item.isManualLine) {
              duplicateData.isManualLine = false;
              duplicateData.eligibleUnit = (item.invoiceUnits - item.totalReturnUnits) > 0 ? (item.invoiceUnits - item.totalReturnUnits) : 0;
              duplicateData.isParent = item.isParent;
              duplicateData.invoiceType = item.invoiceType;
              duplicateData.invoiceUnits = item.invoiceUnits;
              duplicateData.invoicedProductId = item.invoicedProductId;
              duplicateData.isEligible = true;
              duplicateData.isManualLine = false;
              duplicateData.isParent = item.isParent;
              duplicateData.isSelected = item.isSelected;
              duplicateData.lineStatus = '';
              duplicateData.originalInvoiceDate = item.originalInvoiceDate;
              duplicateData.originalInvoiceEndDate = duplicateData.originalInvoiceEndDate;
              duplicateData.originalInvoiceStartDate = item.originalInvoiceStartDate;
              duplicateData.unitPrice = item.unitPrice;
              this.toastrService.info('Product Added');
              productAdded = false;
            }
            else {
              this.toastrService.warning('Product and Lot # are already on the request');
            }
          }
        });

        this.productAllDataSource.data = orderList;
        this.originalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
        this.enablePlaceOrderAndSaveOrderDraft();

        this.selectedCount = orderList.length;
        this.isAllProductChecked = false;
        this.bindDataSource(orderList, true);
      }
    }));
    this.validateDateFilter();
    this.errorMsgs = new Array();
    this.getScaleTicketTooltip();

    this.productSearchFilter = this.searchTypeList[0].value;

    this.subscription.add(this.broadcastService.on<any>(this.configService.IN_EDIT).subscribe((data) => {
      if (data && data.inEdit === true && this.isInEditActionHasRun === false) {
        this.isInEditActionHasRun = true;
        this.placeRequest(false);
      }
    }));
  }

  getScaleTicketTooltip() {
    this.subscription.add(this.seedReturnService.getScaleTicketFileExtensions().subscribe((result: any) => {
      if (result && result.value) {
        this.scaleTicketTooltip = 'Please upload file type of ' + result.value;
      } else {
        this.scaleTicketTooltip = '';
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Observe Input element change
  ngOnChanges(changes: SimpleChanges) {
    this.productSearchFilter = this.searchTypeList[0].value;
  }

  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      const calendarDate = d;
      // Prevent Saturday and Sunday from being selected.
      return calendarDate >= currentDate;
    };
  }

  public resetProductFilter() {
    this.filterValueList = [];
    this.productFilters = {
      'invoicedProductList': [],
      'invoiceNumberList': [],
      'lotNumberList': [],
      'productName': '',
      'technology': '',
      'treatmentDescription': [],
      'packageSize': [],
      'marketingBrand': [],
      'status': []
    };
  }

  // Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      this.productAllDataSource = new MatTableDataSource(orderList);
      this.productAllDataSource.filterPredicate = (data: any, filter: any) => {
        const technologyFilter = filter.technology.trim().toLowerCase().split(',');

        if ((filter.invoicedProductList.length == 0 || (filter.invoicedProductList.indexOf(data.itemNumber.trim()) > -1))
          && (filter.invoiceNumberList.length == 0 || (filter.invoiceNumberList.indexOf(data.originalInvoiceNumber) > -1))
          && (filter.lotNumberList.length == 0 || (filter.lotNumberList.indexOf(data.lotNumber.trim()) > -1))
          && (filter.marketingBrand.length == 0 || (filter.marketingBrand.indexOf(data.marketingBrand) > -1))
          && (filter.technology == null || filter.technology == '' || (technologyFilter.find(a => data.technology.trim().toLowerCase().includes(a))))
          && (filter.treatmentDescription.length == 0 || (filter.treatmentDescription.indexOf(data.treatmentDescription) > -1))
          && (filter.packageSize.length == 0 || (filter.packageSize.indexOf(data.packageSizeDesc) > -1))
          && (filter.productName == null || (data.itemDescription.trim().toLowerCase().indexOf(filter.productName.trim().toLowerCase()) > -1))
          && (filter.status.length == 0 || (filter.status.indexOf(data.lineStatus) > -1))) {
          this.filterInvoicedProductitems.push(data);
          this.filteredDataCount = this.filteredDataCount + 1;
          return true;
        }
        else {
          return false;
        }
      };
      this.applyFilterData(this.productFilters);
    }
  }

  public selectProductName($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.productName = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.productName = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.productName = this.partialSearchValue;
        }
      }
    }
    else {
      this.resetProductFilter();
    }

    this.keepFilter();
  }

  public selectTechnology($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.technology = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.technology = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.technology = this.partialSearchValue;
        }
      }
    }
    else {
      this.resetProductFilter();
    }

    this.keepFilter();
  }

  public keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.invoicedProductList && this.productFilters.invoicedProductList.length > 0) {
          var strMB = '';
          this.productFilters.invoicedProductList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Item Number : ' + strMB.substr(0, strMB.length - 2));
        }
        if (this.productFilters.lotNumberList && this.productFilters.lotNumberList.length > 0) {
          var strMB = '';
          this.productFilters.lotNumberList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Lot Number : ' + strMB.substr(0, strMB.length - 2));
        }
        if (this.productFilters.invoiceNumberList && this.productFilters.invoiceNumberList.length > 0) {
          let strSS = '';
          this.productFilters.invoiceNumberList.forEach(x => {
            strSS = strSS + x + ', ';
          });
          this.filterValueList.push('Invoice Number : ' + strSS.substr(0, strSS.length - 2));
        }
        // Set Product Name
        if (this.productFilters.productName && this.productFilters.productName != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.productName);
        }

        // Set Package Size
        if (this.productFilters.packageSize && this.productFilters.packageSize.length > 0) {
          var strINO = '';
          this.productFilters.packageSize.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strINO.substr(0, strINO.length - 2));
        }

        // Set Treatment
        if (this.productFilters.treatmentDescription && this.productFilters.treatmentDescription.length > 0) {
          var strINO = '';
          this.productFilters.treatmentDescription.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strINO.substr(0, strINO.length - 2));
        }

        // Set Technology
        if (this.productFilters.technology && this.productFilters.technology != '') {
          this.filterValueList.push('Technology : ' + this.productFilters.technology);
        }

        // Set marketing brand
        if (this.productFilters.marketingBrand && this.productFilters.marketingBrand.length > 0) {
          var strINO = '';
          this.productFilters.marketingBrand.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strINO.substr(0, strINO.length - 2));
        }
        // Set status
        if (this.productFilters.status && this.productFilters.status.length > 0) {
          var strINO = '';
          this.productFilters.status.forEach(x => {
            if (x === 'REJECTED') { strINO = strINO + x + ', reject, '; }
            else {
              strINO = strINO + x + ', ';
            }
          });
          this.filterValueList.push('Status : ' + strINO.substr(0, strINO.length - 2));
        }
      }
    }
    this.applyFilterData(this.productFilters);
    this.searchValue = '';
    this.partialSearchValue = '';
  }

  // Filter grid data on type
  applyFilterData(filterValue: any) {
    this.filterInvoicedProductitems = [];
    this.filteredDataCount = 0;

    this.productAllDataSource.filter = filterValue;
    this.filterInvoicedProductitems.forEach(item => {
      if (item.isSelected) {
        this.checkBoxCount = this.checkBoxCount + 1;
      }
    });
  }

  public filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.value.toLocaleLowerCase().indexOf(term) > -1;
  }

  public partialSearch(searchValue: string) {
    if (searchValue != undefined) {
      this.partialSearchValue = searchValue;
    }
  }

  public clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    this.productList = new Array();
    this.resetProductFilter();
    this.applyFilterData(this.productFilters);
    this.isAllProductChecked = false;
  }

  public clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);
      this.applyFilterData(this.productFilters);
    }
  }

  // To remove clear search filter
  public removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Item Number':
        this.productFilters.invoicedProductList = [];
        break;
      case 'Invoice Number':
        this.productFilters.invoiceNumberList = [];
        break;
      case 'Lot Number':
        this.productFilters.lotNumberList = [];
        break;
      case 'Product Name':
        this.productFilters.productName = '';
        break;
      case 'Marketing Brand':
        this.productFilters.marketingBrand = [];
        break;
      case 'Technology':
        this.productFilters.technology = '';
        break;
      case 'Treatment':
        this.productFilters.treatmentDescription = [];
        break;
      case 'Package Size':
        this.productFilters.packageSize = [];
        break;
      case 'Status':
        this.productFilters.status = [];
        break;
      default:
        break;
    }
  }

  // Tab changed
  tabChanged(tab) {
    // this.setHeight();
    if (tab.index == 1) {
      this.isSearchClicked = true;
      this.editToolKit = false;
      this.enableAllCheckBoxes(false);
    } else {
      this.showScaleTabs = false;
      this.EnableAllEditToolKit(false);
    }
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  // Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Design : Set height
  setHeight() {
    const createTemplateHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.create-return-outer').css('max-height', createTemplateHeight + 'px');
  }

  // Edit/Approval screen enable/disbale buttons
  editButtonStatus() {
    this.disablecheckbox = false;
    this.disableScaleCheckbox = false;
    this.seedReturnService.setEditModeStatus(true);
    this.isAddProductEnable = true;
    this.enableCreate = false;
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.seedReturnService.getEditRequestDetail(this.returnRequestId).subscribe((result: any) => {
      this.seedReturnService.setEditModeStatus(true);
      this.isAutoApprove = result.hasAutoApproveAccess;
      if (this.isAutoApprove) {
        this.isAutoApprove = this.checkReturnPeriodApprovalAccess(MasterConstants.PRODUCT_LINE_SOYBEAN_CODE);
      }
      this.isEditMode = true;
      this.seedReturnService.returnRequestStatus = result.returnRequestStatus;
      this.accountEmail = result.email;
      this.oldEmail = result.email;
      this.requestStatus = result.returnRequestStatus;
      if (result.returnRequestStatus === 'DRAFT') {
        this.isSaveOrderDraftEnable = true;
      } else {
        this.isSaveOrderDraftEnable = false;
      }
      this.enableCreate = false;
      this.editApprovalList = result;
      this.disablecheckbox = false;
      this.disableScaleCheckbox = false;
      if (result.seedReturnProductList && result.seedReturnProductList.length > 0) {
        const blnAddProductPermission = this.checkAddProductEnable();
        result.seedReturnProductList.forEach(x => {
          x.isSelected = false;
          x.eligibleUnit = x.isManualLine ? 0 : x.eligibleUnit;
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
          if ((x.lineStatus == 'PENDING' || x.lineStatus == 'APPROVED') && !blnAddProductPermission) {
            x.isIncreaseQtyDisable = true;
            x.isDecreaseQtyDisable = true;
          }
          else {
            x.isIncreaseQtyDisable = false;
            x.isDecreaseQtyDisable = false;
          }
        });
      }
      this.returnRequestNumber = result.returnRequestNumber;
      this.shipToAccount = result.shipToAccountId;
      if (this.shipToAccountItems) {
        const accountItem = this.shipToAccountItems.filter(x => x.accountNumber === this.shipToAccount);
        if (accountItem && accountItem.length > 0) {
          this.selectedAccountName = accountItem[0].accountName;
          this.shipToAccountName = accountItem[0].accountName;
        }
      }
      this.seedReturnService.setSelectedAccountNo(this.shipToAccount);
      this.dsmInfo = result.dsmName;
      this.dsmId = result.dsmId;
      this.isParent = result.isParent;
      if (this.requestStatus === 'PENDING' || this.requestStatus === 'DRAFT' || this.requestStatus === 'IN EDIT') {
        this.getFilterMasterList();
      }
      this.seedReturnService.setProductList(result.seedReturnProductList);
      this.originalProductItemsDataSource = [];
      this.bindDataSource(result.seedReturnProductList, true);
      this.originalProductItemsDataSource = JSON.parse(JSON.stringify(result.seedReturnProductList));
      this.seedReturnProductListOriginalData = JSON.parse(JSON.stringify(result.seedReturnProductList));
      this.scaleTicketList = result.scaleTicketList;
      this.scaleTicketDataSource.data = result.scaleTicketList;
      this.selectedCount = result.seedReturnProductList.length;
      this.checkBoxCount = 0;
      this.requestedByUser = result.requestedBy;
      this.onBehalfUser = result.requestedBy;
      this.getUserList(this.shipToAccount);
      this.scaleTicketDataSource.data.forEach(x => {
        x.uploadedAt = this.datePipe.transform(x.uploadedAt, 'MM/dd/yyyy');
      });

      if (this.isEditMode && this.requestStatus != 'DRAFT' && this.requestStatus != 'PENDING' && this.requestStatus != 'IN EDIT' && this.requestStatus != 'APPROVED' && ((this.requestStatus != 'ERROR' || !this.isApprovalAccess))) {
        // this.readOnlyAccess = true;
        this.reviewRequestMode = true;
      }
      else if (this.requestStatus == 'IN EDIT' && this.checkAddProductEnable()) {
        this.reviewRequestMode = false;
        this.isAddProductEnable = true;
      }
      else if (this.isEditMode && this.requestStatus == 'PENDING') {
        this.reviewRequestMode = false;
        this.isAddProductEnable = false;
      }
      else if (this.isApprovalAccess && this.isEditMode && this.requestStatus != 'DRAFT') {
        this.displayedColumns = ['checkbox', 'product', 'lotNumber', 'uom', 'units', 'dumpedUnits', 'notes', 'approverNotes'];
      }

      this.enableFiltersAndButtonAsPermission();
      this.loaderService.setLoaderStatus(false);
      this.enablePlaceOrderAndSaveOrderDraft();
      this.isScaleTicketEnable = true;
      this.seedReturnService.setSelectedAccountNo(result.shipToAccountId);
      const approvedItem = result.seedReturnProductList.filter(x => x.lineStatus == 'APPROVED');
      if (approvedItem.length > 0) {
        this.isRequestPending = false;
      }
      if (this.showSubmitToJde && result.returnRequestStatus.trim() === 'ERROR') {
        result.seedReturnProductList.filter(x => x.lineStatus == 'APPROVED').forEach(x => {
          x = this.validateApprovedItems(x);
          if (x.lineErrors.errors.length > 0) {
            this.errorMsgs.push(x.lineErrors);
            this.getCommonErrors(this.errorMsgs);
          }
        });
        this.showErrorBlock = false;
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  validateApprovedItems(item: any) {
    const seedPerbag = 140000;
    const cbotPricePerBushel = item.cbotPricePerBushel;
    const poundPerBushel = 60;
    let adjustmentPrice = 0;
    if (parseFloat(item.seedsPerPound) > 0) {
      adjustmentPrice = (seedPerbag / parseFloat(item.seedsPerPound)) * (parseFloat(cbotPricePerBushel) / poundPerBushel);
    }
    // seedPerPoundExist
    if (!item.seedsPerPound) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'seedPerPoundExist');
      item.lineErrors.errors.push({
        id: 'seedPerPoundExist', error: 'Seeds per pound cannot be found to calculate the price adjustment.'
      });
      item.lineError = true;
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'seedPerPoundExist');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // cbotPriceExist
    if (+item.cbotPricePerBushel <= 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'cbotPriceExist');
      item.lineErrors.errors.push({ id: 'cbotPriceExist', error: 'CBOT price does not exist for item' });
      item.lineError = true;
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'cbotPriceExist');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // adjustmentPrice
    if (+adjustmentPrice < 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'adjustmentPrice');
      item.lineErrors.errors.push({ id: 'adjustmentPrice', error: 'The calculated credit price is less than 0' });
      item.lineError = true;
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'adjustmentPrice');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // returnQuantity
    if (!item.isManualLine && parseInt(item.returnQuantity) > parseInt(item.eligibleUnit)) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'returnQuantity');
      item.lineErrors.errors.push({ id: 'returnQuantity', error: 'Dumped units cannot exceed the Eligible Units' });
      item.lineError = true;
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'returnQuantity');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // manualLine
    if (item.isManualLine) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'manualLine');
      item.lineErrors.errors.push({ id: 'manualLine', error: 'There is no record of purchase for this item and lot number.' });
      item.lineError = true;
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'manualLine');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }
    this.originalProductItemsDataSource.find(data => data.itemId === item.itemId && data.lotNumber == item.lotNumber).lineError = item.lineError;
    this.originalProductItemsDataSource.find(data => data.itemId === item.itemId && data.lotNumber == item.lotNumber).isManualLine = item.isManualLine;
    return item;
  }

  getUserList(accountNumber) {
    const self = this;
    this.subscription.add(this.seedReturnService.getAccountUser(accountNumber).subscribe((result: any) => {
      if (result.length > 0) {
        this.requestOnBehalfList = result;
        if (this.currentRequestedUser) {
          const requestItem = this.requestOnBehalfList.filter(r => r.userId == this.currentRequestedUser);
          this.onBehalfUser = requestItem[0].userId;
          this.accountEmail = this.isShowNonSubEmail ? this.accountEmail : requestItem[0].userEmail;
          this.requestedByUser = requestItem[0].userId;
        }
        if (self.onBehalfUser && self.requestOnBehalfList.filter(r => r.userId == self.onBehalfUser)[0] === undefined) {
          self.accountEmail = null;
          self.onBehalfUser = null;
        }
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  enableFiltersAndButtonAsPermission() {
    if (this.isApprovalAccess && this.isEditMode && this.requestStatus != 'DRAFT' && this.requestStatus != 'IN EDIT') {
      this.displayedColumns = ['checkbox', 'product', 'lotNumber', 'uom', 'units', 'dumpedUnits', 'notes', 'approverNotes'];
    } else {
      this.displayedColumns = ['checkbox', 'product', 'lotNumber', 'uom', 'units', 'dumpedUnits', 'notes'];
    }

    let isRequestSubmittedAccepted = false;
    if (this.requestStatus != 'PENDING' && this.requestStatus != 'DRAFT' && this.requestStatus != 'IN EDIT') {
      isRequestSubmittedAccepted = true;
    }

    if (this.reviewRequestMode) {
      this.showSubmitReturn = false;
      this.showSubmitToJde = false;
      this.breadcrumbtext = 'Review Dump Request [' + this.returnRequestNumber + ']';
      this.showScaleDelete = false;
    }
    else if (!this.isEditMode) {
      this.showSubmitReturn = true;
      this.showSubmitToJde = false;
      this.breadcrumbtext = 'Create Dump Request';
      this.showScaleDelete = true;
      this.showDelete = true;
    }
    else if (this.isEditMode && (this.requestStatus == 'DRAFT')) {
      this.showSubmitReturn = true;
      this.showSubmitToJde = false;
      this.breadcrumbtext = 'Edit Dump Request [' + this.returnRequestNumber + ']';
      this.showScaleDelete = true;
      this.showDelete = true;
    }
    else if (this.isEditMode && (this.requestStatus == 'IN EDIT')) {
      this.showSubmitReturn = false;
      this.showSubmitToJde = false;
      this.breadcrumbtext = 'Edit Dump Request [' + this.returnRequestNumber + ']';
      this.showScaleDelete = true;
      this.showDelete = true;
      this.leaveWithoutSavingYesButtonText = 'Discard changes and submit request';
    }
    else if (this.isEditMode && !this.isApprovalAccess && this.createRequestAccess && !isRequestSubmittedAccepted && !this.isRequestPending) {
      this.showSubmitReturn = true;
      this.showSubmitToJde = false;
      this.breadcrumbtext = 'Edit Dump Request [' + this.returnRequestNumber + ']';
      this.showScaleDelete = true;
    }
    else if (this.isEditMode && !this.isApprovalAccess && this.createRequestAccess && !isRequestSubmittedAccepted && this.isRequestPending && this.requestStatus == 'IN EDIT') {
      this.showSubmitReturn = false;
      this.showSubmitToJde = true;
      this.breadcrumbtext = 'Edit Dump Request [' + this.returnRequestNumber + ']';
      this.showScaleDelete = true;
      this.leaveWithoutSavingYesButtonText = 'Discard changes and submit request';
    }
    else if (this.isEditMode && !this.isApprovalAccess && this.createRequestAccess && !isRequestSubmittedAccepted && this.isRequestPending && this.requestStatus != 'IN EDIT') {
      this.showSubmitReturn = false;
      this.showSubmitToJde = true;
      this.breadcrumbtext = 'Review Dump Request [' + this.returnRequestNumber + ']';
      this.showScaleDelete = true;
    }
    else if (this.isEditMode && isRequestSubmittedAccepted) {
      this.showSubmitReturn = false;
      this.showSubmitToJde = true;
      this.breadcrumbtext = 'Review Dump Request [' + this.returnRequestNumber + ']';
      this.showScaleDelete = true;
    }
    else if (this.isEditMode && this.isApprovalAccess && this.createRequestAccess) {
      this.showSubmitReturn = false;
      this.showSubmitToJde = true;
      this.breadcrumbtext = 'Approve Dump Request [' + this.returnRequestNumber + ']';
      this.showScaleDelete = true;
    }
    else if (this.isEditMode && this.isApprovalAccess && !this.createRequestAccess) {
      this.showSubmitReturn = false;
      this.showSubmitToJde = true;
      this.breadcrumbtext = 'Approve Dump Request [' + this.returnRequestNumber + ']';
      this.showScaleDelete = true;
    }
  }

  // Enable/Disable Save Draft Button and Place Order Button
  enablePlaceOrderAndSaveOrderDraft() {
    if (this.reviewRequestMode) {
      this.isSaveOrderDraftEnable = false;
      this.isPlaceOrderEnable = false;
    }
    else {
      if (this.productAllDataSource && this.productAllDataSource.data.length > 0 && this.shipToAccount && (!this.isNotValid)) {
        if (this.isEditMode && this.requestStatus !== 'DRAFT') {
          this.isSaveOrderDraftEnable = false;
          if (this.checkAnyValidLineItem()) {
            this.isPlaceOrderEnable = true;
          } else {
            this.isPlaceOrderEnable = false;
          }
        } else {
          if (this.checkAnyValidLineItem()) {
            this.isSaveOrderDraftEnable = true;
            this.isPlaceOrderEnable = true;
          } else {
            this.isSaveOrderDraftEnable = false;
            this.isPlaceOrderEnable = false;;
          }
        }
      }
      else {
        this.isSaveOrderDraftEnable = false;
        this.isPlaceOrderEnable = false;
      }
    }
  }

  showProductDetails(item) {
    item.isProductDetailDisplayed = !item.isProductDetailDisplayed;
  }

  // Load master data
  loadMasterData() {
    this.subscription.add(this.seedReturnService.getAccountUser(0).subscribe((result: any) => {
      this.requestOnBehalfList = result;
      if (!this.isEditMode) {
        this.onBehalfUser = this.requestOnBehalfList[0].userId;
        this.accountEmail = this.isShowNonSubEmail ? '' : this.requestOnBehalfList[0].userEmail;
        this.requestedByUser = this.requestOnBehalfList[0].userId;
        this.currentRequestedUser = this.requestOnBehalfList[0].userId;
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // for adding product
  addProduct() {
    this.seedReturnAddProductSliderModelService.activeSlider('AddSeedReturnProductSlider');
  }

  enableAllCheckBoxes(isChecked) {
    this.isAllProductChecked = isChecked;
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.editToolKit = true;
      this.productAllDataSource.filteredData.forEach(x => {
        if (this.isValidApproveReject(x.productLine, x.marketingBrandId)) {
          if (x.lineStatus !== 'REJECTED' && x.lineStatus !== 'APPROVED') {
            x.isSelected = true;
          }
          else if ((x.lineStatus === 'REJECTED' || x.lineStatus === 'APPROVED') && x.returnRequestItemId == 0) {
            x.isSelected = true;
          }
        }
      });
      this.checkBoxCount = this.productAllDataSource.filteredData.filter(x => x.isSelected == true).length;
      const selectedItem = this.productAllDataSource.filteredData.filter(x => x.isSelected == true);
      if (selectedItem && selectedItem.length > 0) {
        this.isValidLineStatus = selectedItem.filter(item => item.lineStatus == 'ERROR' || item.lineStatus == 'PENDING').length > 0 ? false : true;
        this.editToolKit = true;
        if (this.isValidLineStatus && this.seedReturnService.getEditModeStatus()) {
          this.showTabs = true;
          this.isSearchClicked = false;
        } else if (!this.isValidLineStatus && this.seedReturnService.getEditModeStatus() && !this.isApprovalAccess) {
          this.editToolKit = false;
        }
      }
      else {
        this.editToolKit = false;
      }
    }
    else {
      this.showTabs = false;
      this.editToolKit = false;
      this.productAllDataSource.data.forEach(x => {
        x.isSelected = false;
      });
      this.checkBoxCount = 0;
    }
  }

  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.editToolKit = true;

      this.checkBoxCount = this.productAllDataSource.filteredData.filter(x => x.isSelected == true).length;
      const checked = this.productAllDataSource.filteredData.filter(x => x.lineStatus !== 'REJECTED' && x.lineStatus !== 'APPROVED' && x.isSelected == false);

      if (checked && checked.length == 0) {
        this.isAllProductChecked = true;
      }
      else {
        this.isAllProductChecked = false;
      }
    }
    else {
      this.checkBoxCount = this.checkBoxCount - 1;
      this.isAllProductChecked = false;
      const selected = this.productAllDataSource.filteredData.filter(x => x.isSelected == true);
      {
        if (selected && selected.length == 0) {
          this.showTabs = false;
        }
        else {
          this.showTabs = true;
        }
      }
    }
    this.editToolKit = false;
    const selectedItem = this.productAllDataSource.filteredData.filter(x => x.isSelected == true);
    this.isValidLineStatus = false;
    if (selectedItem.length > 0) {
      this.isValidLineStatus = selectedItem.filter(item => item.lineStatus == '' || item.lineStatus == null || item.lineStatus == 'DRAFT' || item.returnRequestItemId == 0).length > 0 ? true : false;
      this.editToolKit = true;
      if (this.isValidLineStatus && this.seedReturnService.getEditModeStatus()) {
        this.showTabs = true;
        this.isSearchClicked = false;
      } else if (!this.isValidLineStatus && this.seedReturnService.getEditModeStatus() && !this.isApprovalAccess) {
        this.editToolKit = false;
      }
    }
  }

  enableTicketCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.showScaleTabs = true;
      this.selectedTicketCount = this.scaleTicketDataSource.data.filter(x => x.isSelected == true).length;
      const checked = this.scaleTicketDataSource.data.filter(x => x.isSelected == false);
      if (checked && checked.length == 0) {
        this.allTicketChecked = true;
      }
      else {
        this.allTicketChecked = false;
      }
    }
    else {
      this.selectedTicketCount = this.selectedTicketCount - 1;
      this.allTicketChecked = false;
      const checked = this.scaleTicketDataSource.data.filter(x => x.isSelected == true);
      {
        if (checked && checked.length == 0) {
          this.showScaleTabs = false;
        }
      }
    }
  }
  // Set Tab to show
  showTab(tabid: string) {
    this.tabNode = tabid;
    if (this.tabNode === 'approve' || this.tabNode === 'reject') {
      this.productAllDataSource.filteredData.forEach(x => {
        if (x.isSelected) {
          x.lineErrors.errors = [];
          x.lineError = false;
          if (this.tabNode === 'reject') {
            // Approver Notes - Scenario Edit/Approval
            if (!x.approverNotes) {
              x.lineErrors.errors === x.lineErrors.errors.filter(y => y.id !== 'approverNotes');
              x.lineErrors.errors.push({ id: 'approverNotes', error: 'Enter reason for rejection in Approver Notes before submitting.' });
            }
            else {
              x.lineErrors.errors === x.lineErrors.errors.filter(y => y.id !== 'approverNotes');
              var index = this.errorMsgs.findIndex(element => element.itemId === x.itemId && element.lotNumber === x.lotNumber);
              if (index !== -1) {
                this.errorMsgs.splice(index, 1);
              }
            }
          }
          // Use case 6 step 3) Note that the system does not run validations on lines that are rejected.
          if (this.tabNode === 'approve') {
            if (x.isManualLine) {
              x.lineErrors.errors = x.lineErrors.errors.filter(y => y.id != 'manualLine');
              x.lineErrors.errors.push({ id: 'manualLine', error: 'There is no record of purchase for this item and lot number.' });
            }
            else {
              x.lineErrors.errors = x.lineErrors.errors.filter(y => y.id != 'manualLine');
              var index = this.errorMsgs.findIndex(function (element) {
                return element.itemId === x.itemId && element.lotNumber === x.lotNumber;
              });
              if (index !== -1) {
                this.errorMsgs.splice(index, 1);
              }
            }
            x = this.validateLineItem(x);
          }
          if (x.lineErrors.errors.length > 0 && this.tabNode == 'approve') {
            x.lineErrors.errors = x.lineErrors.errors.filter(y => y.id != 'JDEPendingStatus');
            if (x.lineErrors.errors.length == 0) {
              x.lineStatus = 'APPROVED';
            }
          }
          else if ((x.lineErrors.errors.length === 0 && this.tabNode === 'approve') || (x.lineErrors.errors.length === 0 && this.tabNode === 'reject')) {
            x.lineStatus = this.tabNode === 'approve' ? 'APPROVED' : 'REJECTED';
            if (this.tabNode === 'reject') {
              x.editable = true;
            }
            x.lineErrors.errors = [];

            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).lineStatus = x.lineStatus;
            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).returnQuantity = x.returnQuantity;
          }
          if (x.lineErrors.errors.length > 0) {
            this.errorMsgs.push(x.lineErrors);
            this.getCommonErrors(this.errorMsgs);
          }
        }
      });

      this.productAllDataSource.data.forEach(x => {
        if (x.isSelected && (x.lineStatus === 'APPROVED' || (x.lineStatus === 'REJECTED'))) {
          x.lineErrors.errors = [];
        }
      });

      this.applyFilterData(this.productFilters);

      const productAllList = this.productAllDataSource.data;
      this.errorMsgs = this.errorMsgs.filter(function (orgItems) {
        return productAllList.find(function (allItems) {
          return orgItems.itemId === allItems.itemId && orgItems.lotNumber === allItems.lotNumber;
        });
      });
      this.isAllProductChecked = false;
      this.showTabs = false;
      this.editToolKit = false;
      this.productAllDataSource.data.forEach(x => {
        x.isSelected = false;
      });
      this.editToolKit = false;
      this.checkBoxCount = 0;
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true, labelNo: this.leaveWithoutSavingNoButtonText, inEdit: this.requestStatus === 'IN EDIT' });
    }

    const result = this.productAllDataSource.filteredData.filter(x => x.lineStatus == 'APPROVED');
    if (result.length > 0) {
      this.isRequestPending = false;
    } else {
      this.isRequestPending = true;
    }
  }

  getFilterMasterList() {
    if (this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.invoicedProductList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST));
    }
    this.subscription.add(this.seedReturnService.getInvoiceNumberList(this.seedReturnService.getSelectedAccountNo()).subscribe((result: any[]) => {
      this.invoiceNumberList = result;
    }));

    // Treatment master list
    if (this.localStorageService.get(MasterConstants.ALL_TREATMENT_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_TREATMENT_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST)) {
      this.packageSizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST));
    }

    // Marketing brand master data
    if (this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST)) {
      this.marketingBrandMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST));
    }

    // Technology master list
    if (this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST)) {
      this.technologyMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST));
    }

    this.subscription.add(this.seedReturnService.getLotMasterList(this.shipToAccount).subscribe((result: any[]) => {
      if (result && result.length > 0) {
        this.lotNumberList = result.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
      }
    }));
  }

  hasEmailAddressChanged() {
    if (this.isEditMode) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { seedReturnEmailAddressValue: true, labelNo: this.leaveWithoutSavingNoButtonText, inEdit: this.requestStatus === 'IN EDIT' });
    }
  }

  setUserEmail(event) {
    if (event) {
      this.accountEmail = event.userEmail;
      this.selectedUserName = event.userName;
      this.requestedByUser = event.userId;
    } else {
      this.accountEmail = null;
      this.requestedByUser = null;
      this.selectedUserName = null;
    }
    if (this.isEditMode) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { hasReturnRequestOnBehalfOfChange: true, labelNo: this.leaveWithoutSavingNoButtonText, inEdit: this.requestStatus === 'IN EDIT' });
    }
  }

  getShipTo(event) {
    if (event) {
      this.dsmInfo = '';
      this.isAddProductEnable = true;
      this.isScaleTicketEnable = true;
      this.selectedAccountName = event.accountName;
      this.shipToAccount = event.accountNumber;
      this.seedReturnService.setSelectedAccountNo(event.accountNumber);
      this.seedReturnService.setSelectedParentAccountNo(event.parentNumber);
      this.getFilterMasterList();
      this.subscription.add(this.seedReturnService.getDSMInfo(event.accountNumber, this.cropYear).subscribe((result: any) => {
        this.dsmInfo = result && result.dsmAccountName ? result.dsmAccountName : '';
        this.dsmId = result && result.dsmId ? result.dsmId : 0;
      }, error => this.loaderService.setLoaderStatus(false)));
      this.getUserList(event.accountNumber);
      this.checkAutoApproval(event.accountNumber);
      // get lot list based on selected account
    } else {
      this.dsmInfo = '';
      this.dsmId = 0;
      this.isAddProductEnable = false;   // Disable Add Product Button
      this.isScaleTicketEnable = false; // Disable Scale Ticket button
      this.invoicedProductList = [];
      this.invoiceNumberList = [];
      if (this.currentRequestedUser) {
        const requestItem = this.requestOnBehalfList.filter(r => r.userId == this.currentRequestedUser);
        this.onBehalfUser = requestItem[0].userId;
        this.accountEmail = this.isShowNonSubEmail ? this.accountEmail : requestItem[0].userEmail;
        this.requestedByUser = requestItem[0].userId;
      }
      this.isAutoApprove = false;
    }

    this.clearAllFilter();
    this.productSearchFilter = this.searchTypeList[0].value;
    this.disablecheckbox = true;
    this.errorMsgs = new Array();
    this.showErrorBlock = false;
    this.editToolKit = false;
    this.showTabs = false;
    this.originalProductItemsDataSource = [];
    this.scaleTicketDataSource = new MatTableDataSource([]);
    this.bindDataSource([], true);
    this.scaleTicketList = [];
    this.checkBoxCount = 0;
    this.selectedCount = 0;
    this.isSearchClicked = true;
    this.editToolKit = false;
    this.enableAllCheckBoxes(false);
    this.showScaleTabs = false;
    this.EnableAllEditToolKit(false);
    this.enablePlaceOrderAndSaveOrderDraft();

  }

  placeRequest(isSubmit: boolean) {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');

    const isValidated = true;
    if (this.validateOrder()) {
      this.loaderService.setLoaderStatus(true);
      this.isPlaceOrderEnable = false;
      let productList: any;
      if (isSubmit) {
        productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
      } else {
        productList = this.seedReturnProductListOriginalData;
      }
      const newLineItems = [];
      productList.filter(x => {
        if (x.lineStatus === '' || x.lineStatus === null || x.lineStatus === 'DRAFT') {
          newLineItems.push(JSON.parse(JSON.stringify(x)));
        }
        x.lineStatus = (x.lineStatus === null || x.lineStatus === '' || x.lineStatus === 'DRAFT') ? 'PENDING' : x.lineStatus;
        x.errorMessage = null;
      });

      const item = this.requestOnBehalfList.filter(r => r.userId == this.requestedByUser)[0];
      if (this.requestedByUser && item) {
        this.selectedUserName = item.userName;
      }
      const postData = {
        returnRequestId: this.returnRequestId,
        ReturnRequestType: 'SOYBEAN',
        ReturnRequestStatus: 'PENDING',
        CompanyCode: this.headerCompany,
        IsUpdateRequest: this.seedReturnService.getEditModeStatus(),
        ShipToAccountId: this.shipToAccount,
        DsmId: this.dsmId,
        BranchPlant: null,
        SeedReturnProductList: productList,
        ScaleTicketList: this.scaleTicketList,
        Email: isSubmit ? this.accountEmail : this.oldEmail,
        EmailUserName: this.selectedUserName,
        Requestedby: this.requestedByUser,
        ProductLine: MasterConstants.PRODUCT_LINE_SOYBEAN_CODE
      };

      this.subscription.add(this.seedReturnService.submitReturnRequest(postData).subscribe((result: any) => {
        if (result) {
          const errorCount = result.seedReturnProductList.filter(x => x.errorMessage != null).length;
          if (errorCount > 0) {
            this.productAllDataSource.data = result.seedReturnProductList;
            this.productAllDataSource.data.forEach(x => {
              const item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
              if (item.length > 0) {
                x.lineStatus = item[0].lineStatus;
              }
              if (x.errorMessage != '' && x.errorMessage != null) {
                x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [{ 'error': x.errorMessage }] };
                this.errorMsgs.push(x.lineErrors);
              }
              else {
                x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
              }
            });
            this.getCommonErrors(this.errorMsgs);
            this.loaderService.setLoaderStatus(false);
          } else {
            this.toastrService.success('Return request placed successfully.');
            this.seedReturnService.webOrderNumberAndSplitId = result.jdeOrderNumber + '-' + 0 + '- ' + '-SeedReturn';// Done '- ' so that we could show non errored data
            this.router.navigate(['/seed-returns-soybean-dashboard']);

            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });

            this.loaderService.setLoaderStatus(false);
          }
        }
      }, error => {
        this.isPlaceOrderEnable = true;
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Return Request not saved in the system.');
      }));
    } else {
      this.isPlaceOrderEnable = false;
    }
  }

  saveDraft() {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');

    const isValidated = true;
    if (this.validateOrder()) {
      this.isPlaceOrderEnable = false;
      this.isSaveOrderDraftEnable = false;
      const productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
      const newLineItems = [];
      productList.filter(x => {
        newLineItems.push(JSON.parse(JSON.stringify(x)));
        x.lineStatus = 'DRAFT';
        x.errorMessage = null;
      });
      const postData = {
        ReturnRequestId: this.returnRequestId,
        ReturnRequestType: 'SOYBEAN',
        ReturnRequestStatus: 'DRAFT',
        CompanyCode: this.headerCompany,
        ShipToAccountId: this.shipToAccount,
        IsUpdateRequest: this.seedReturnService.getEditModeStatus(),
        DsmId: this.dsmId,
        BranchPlant: null,
        SeedReturnProductList: productList,
        ScaleTicketList: this.scaleTicketList,
        Email: this.accountEmail,
        RequestedBy: this.requestedByUser,
        ProductLine: MasterConstants.PRODUCT_LINE_SOYBEAN_CODE
      };
      this.loaderService.setLoaderStatus(true);

      this.subscription.add(this.seedReturnService.submitReturnRequest(postData).subscribe((result: any) => {
        if (result) {
          const errorCount = result.seedReturnProductList.filter(x => x.errorMessage != null).length;
          if (errorCount > 0) {
            this.productAllDataSource.data = result.seedReturnProductList;
            this.productAllDataSource.data.forEach(x => {
              const item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
              if (item.length > 0) {
                x.lineStatus = item[0].lineStatus;
              }
              if (x.errorMessage != '' && x.errorMessage != null) {
                x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [{ 'error': x.errorMessage }] };
                this.errorMsgs.push(x.lineErrors);
              }
              else {
                x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
              }
            });
            this.getCommonErrors(this.errorMsgs);
            this.loaderService.setLoaderStatus(false);
          } else {
            const successMsg = 'Return Request saved successfully.';
            this.toastrService.success(successMsg);
            this.router.navigate(['/seed-returns-soybean-dashboard']);
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
            this.loaderService.setLoaderStatus(false);
          }
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
        this.isPlaceOrderEnable = true;
        this.isSaveOrderDraftEnable = true;
        this.toastrService.error('Return Request not saved in the system.');
      }));
    }
  }

  saveRequest() {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    // this.revertAllChanges();
    this.isPlaceOrderEnable = false;
    this.editApprovalList.isUpdateRequest = true;
    const productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
    const newLineItems = [];
    productList.filter(x => {
      if (x.lineStatus === '' || x.lineStatus === null) {
        newLineItems.push(JSON.parse(JSON.stringify(x)));
      }
      if (x.lineStatus === '' || x.lineStatus === null) {
        x.lineStatus = 'PENDING';
      }
      else if (x.lineStatus === 'approve') {
        x.lineStatus = 'APPROVED';
      }
      else if (x.lineStatus === 'reject') {
        x.lineStatus = 'REJECTED';
      }
      x.errorMessage = null;
    });
    this.editApprovalList.seedReturnProductList = productList;
    this.editApprovalList.scaleTicketList = this.scaleTicketList;
    this.editApprovalList.email = this.accountEmail;
    this.editApprovalList.emailUserName = this.selectedUserName;
    this.editApprovalList.requestedBy = this.requestedByUser;
    const isValidated = true;

    if (this.isScaleTicketEnable && this.reviewRequestMode) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.add(this.seedReturnService.submitScaleTickets(this.editApprovalList).subscribe((result: any) => {
        if (result) {
          this.toastrService.success('Return request has been saved successfully.');
          this.seedReturnService.webOrderNumberAndSplitId = result.jdeOrderNumber + '-' + 0 + '- ' + '-SeedReturn';// Done '- ' so that we could show non errored data
          this.router.navigate(['/seed-returns-soybean-dashboard']);

          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });

          this.loaderService.setLoaderStatus(false);
        }
      }, error => {
        this.isPlaceOrderEnable = true;
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Return Request not saved in the system.');
      }));
    }
    else {
      if (this.validateOrder()) {
        this.loaderService.setLoaderStatus(true);
        this.subscription.add(this.seedReturnService.submitReturnRequest(this.editApprovalList).subscribe((result: any) => {
          if (result) {
            const errorCount = result.seedReturnProductList.filter(x => x.errorMessage != null).length;
            if (errorCount > 0) {
              this.productAllDataSource.data = result.seedReturnProductList;
              this.productAllDataSource.data.forEach(x => {
                const item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
                if (item.length > 0) {
                  x.lineStatus = item[0].lineStatus;
                }
                if (x.errorMessage != '' && x.errorMessage != null) {
                  x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [{ 'error': x.errorMessage }] };
                  this.errorMsgs.push(x.lineErrors);
                }
                else {
                  x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
                }
              });
              this.getCommonErrors(this.errorMsgs);
              this.loaderService.setLoaderStatus(false);
            } else {
              this.toastrService.success('Return request has been saved successfully.');
              this.seedReturnService.webOrderNumberAndSplitId = result.jdeOrderNumber + '-' + 0 + '- ' + '-SeedReturn';// Done '- ' so that we could show non errored data
              this.router.navigate(['/seed-returns-soybean-dashboard']);

              this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });

              this.loaderService.setLoaderStatus(false);
            }
          }
        }, error => {
          this.isPlaceOrderEnable = true;
          this.loaderService.setLoaderStatus(false);
          this.toastrService.error('Return Request not saved in the system.');
        }));
      }
    }
  }

  submitJDERequest() {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    this.isPlaceOrderEnable = false;
    this.editApprovalList.isUpdateRequest = true;
    const productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
    const newLineItems = [];
    productList.filter(x => {
      if (x.lineStatus === '' || x.lineStatus === null) {
        newLineItems.push(JSON.parse(JSON.stringify(x)));
      }
      if (x.lineStatus === '' || x.lineStatus === null) {
        x.lineStatus = 'PENDING';
      }
      else if (x.lineStatus === 'approve') {
        x.lineStatus = 'APPROVED';
      }
      else if (x.lineStatus === 'reject') {
        x.lineStatus = 'REJECTED';
      }
      x.errorMessage = null;
    });
    const item = this.requestOnBehalfList.filter(r => r.userId == this.requestedByUser)[0];
    if (this.requestedByUser && item) {
      this.selectedUserName = item.userName;
    }

    this.editApprovalList.seedReturnProductList = productList;
    this.editApprovalList.scaleTicketList = this.scaleTicketList;
    this.editApprovalList.email = this.accountEmail;
    this.editApprovalList.emailUserName = this.selectedUserName;
    this.editApprovalList.requestedBy = this.requestedByUser;
    const isValidated = true;
    if (this.validateJDEOrder()) {
      const acceptedItem = productList.filter(x => x.lineStatus === 'APPROVED')[0];
      if (acceptedItem === undefined) {
        this.toastrService.error('There is no approved line to Submit ');
        return;
      }
      this.loaderService.setLoaderStatus(true);
      this.subscription.add(this.seedReturnService.submitToJDEReturnRequest(this.editApprovalList).subscribe((result: any) => {
        if (result) {
          const errorCount = result.seedReturnProductList.filter(x => x.errorMessage != null).length;
          if (errorCount > 0) {
            this.productAllDataSource.data = result.seedReturnProductList;
            this.productAllDataSource.data.forEach(x => {
              const item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
              if (item.length > 0) {
                x.lineStatus = item[0].lineStatus;
              }
              this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).lineError = x.lineError;
              this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).isManualLine = x.isManualLine;
              // this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).isManualLine = x.isManualLine;
              if (x.errorMessage != '' && x.errorMessage != null) {
                x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [{ 'error': x.errorMessage }] };
                x.lineError = true;
                this.errorMsgs.push(x.lineErrors);
              }
              else {
                x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
                x.lineError = true;
              }
            });
            this.getCommonErrors(this.errorMsgs);
            this.loaderService.setLoaderStatus(false);
          } else {
            const successMsg = 'Return Request submitted successfully.';
            this.toastrService.success(successMsg);
            this.router.navigate(['/seed-returns-soybean-dashboard']);
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
            this.loaderService.setLoaderStatus(false);
          }
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Return Request not saved in the system.');
      }));
    }
  }

  // Convert File To Base64
  convertFileToBase64(file, callback) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      callback(reader.result, file.name);
    };
    reader.onerror = function (error) {
      LolLoggerService.info('Error: ', error);
    };
  }

  // update grid value from toolKit on update
  setAllFields(field: string, value: any) {
    switch (field) {
      case 'deleteTicket':
        this.tabNode = '';
        if (value) {
          if (this.isEditMode) {
            let data = [];
            data = this.scaleTicketDataSource.data.filter(x => x.isSelected === true);
            if (data.filter(d => d.scaleTicketId != 0).length > 0) {
              this.loaderService.setLoaderStatus(true);
              this.subscription.add(this.seedReturnService.deleteScaleTicket(data).subscribe((result: any) => {
                if (result) {
                  this.toastrService.success('Selected scale ticket deleted');
                }
                this.loaderService.setLoaderStatus(false);
              }, error => {
                this.loaderService.setLoaderStatus(false);
              }));
            }
          }
          this.scaleTicketDataSource.data = this.scaleTicketDataSource.data.filter(x => x.isSelected != true);
          this.selectedTicketCount = 0;
          this.allTicketChecked = false;
          this.showScaleTabs = false;
        }

        this.scaleTicketList = this.scaleTicketDataSource.data;
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true, labelNo: this.leaveWithoutSavingNoButtonText, inEdit: this.requestStatus === 'IN EDIT' });
        break;
      case 'delete':
        this.tabNode = '';
        if (value) {
          this.isAllProductChecked = false;
          this.showTabs = false;
          this.editToolKit = false;
          let productAllList = [];
          if (this.requestStatus == 'IN EDIT') {
            productAllList = this.productAllDataSource.filteredData.filter(x => x.isSelected === true && x.lineStatus != 'APPROVED');
          } else {
            productAllList = this.productAllDataSource.filteredData.filter(x => x.isSelected === true);
          }

          if (productAllList.length == this.productAllDataSource.data.length) {
            this.errorMsgs = [];
            this.productAllDataSource = new MatTableDataSource([]);
            this.bindDataSource([], true);
            this.originalProductItemsDataSource = [];
          } else {
            productAllList.forEach(items => {
              let index = this.errorMsgs.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber;
              });
              if (index !== -1) {
                this.errorMsgs.splice(index, 1);
              }
              index = this.productAllDataSource.data.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber;
              });
              if (index !== -1) {
                this.productAllDataSource.data.splice(index, 1);
              }

              index = this.originalProductItemsDataSource.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber;
              });
              if (index !== -1) {
                this.originalProductItemsDataSource.splice(index, 1);
              }
            });
          }
          this.applyFilterData(this.productFilters);
          this.checkBoxCount = 0;
          this.selectedCount = this.productAllDataSource.data.length;
          if (this.selectedCount == 0) {
            this.disablecheckbox = true;
          }
        }

        this.enablePlaceOrderAndSaveOrderDraft();
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true, labelNo: this.leaveWithoutSavingNoButtonText, inEdit: this.requestStatus === 'IN EDIT' });
        break;
      default:
        break;
    }
  }

  // Enable Tool Kit
  EnableAllEditToolKit(isChecked: boolean) {
    this.allTicketChecked = isChecked;
    if (isChecked) {
      this.scaleTicketDataSource.data.forEach(x => {
        x.isSelected = true;
      });
      this.selectedTicketCount = this.scaleTicketDataSource.data.length;
      this.showScaleTabs = true;
    }
    else {
      this.showScaleTabs = false;
      this.scaleTicketDataSource.data.forEach(x => {
        x.isSelected = false;
      });
      this.selectedTicketCount = 0;
    }
  }

  uploadTicket($event) {
    const invalidFileTypes = ['exe', 'dll'];

    for (let i = 0; i < $event.target.files.length; i++) {
      var tmppath = URL.createObjectURL($event.target.files[i]);

      const fileData = $event.target.files[i];
      this.scaleTicketDataSource = new MatTableDataSource([]);

      var _this = this;
      this.convertFileToBase64(fileData, function (base64, name) {
        const base64Arr = base64.split(',');
        const file = fileData.name.split('.');
        const item = invalidFileTypes.find(x => x === file[file.length - 1]);
        if (!item) {
          const fileDisplayName = fileData.name.substring(0, fileData.name.lastIndexOf('.'));
          if (base64Arr.length > 0) {
            const scaleTicketVM = {
              fileDisplayName: fileDisplayName,
              fileName: fileData.name,
              fileType: file[file.length - 1],
              fileNameRef: tmppath,
              uploadedAt: _this.datePipe.transform(new Date().toJSON().slice(0, 10).replace(/-/g, '/'), 'MM/dd/yyyy'),
              attachment: base64Arr[1] ? base64Arr[1] : '',
              scaleTicketId: 0,
              isSelected: false,
              mimeType: fileData.type
            };
            _this.scaleTicketList.push(scaleTicketVM);
          } else {
            _this.toastrService.error(fileData.name + '. This file is in use.  Select another file or close the file that is open in another program');
          }
        } else {
          _this.toastrService.error(file[file.length - 1] + ' extension file not allowed to upload');
        }
        _this.scaleTicketDataSource.data = _this.scaleTicketList;
        _this.disableScaleCheckbox = false;
        _this.scaleTicket.nativeElement.value = '';
      });
    };
  }

  downloadTicket(element) {
    if (element.scaleTicketId > 0) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.add(this.seedReturnService.getScaleTicketFile(element.scaleTicketId).subscribe((result: any) => {
        this.openTicket(result);
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));
    }
    else {
      this.openTicket(element);
    }
  }

  base64toFile(base64String, contentType, fileName) {
    const blob = this.b64toBlob(base64String, contentType, 512);
    saveAs(blob, fileName);
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  openTicket(element) {
    this.base64toFile(element.attachment, 'data:' + element.mimeType, element.fileName);
  }

  viewFile(fileData) {
    window.open(fileData);
  }

  validateApprovalQty(item) {
    if (item.lineStatus == 'APPROVED' && !this.isApprovalAccess) {
      const newQty = item.returnQuantity;
      const oldItem = this.originalProductItemsDataSource.filter(x => x.itemId === item.itemId && x.lotNumber === item.lotNumber);
      if (newQty > oldItem[0].returnQuantity) {
        item.isIncreaseQtyDisable = true;
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'increaseQuantity');
        item.lineErrors.errors.push({ id: 'increaseQuantity', error: 'Return quantity cannot be increased for approved items' });
        item.returnQuantity = oldItem[0].returnQuantity;
      }
      else {
        item.isIncreaseQtyDisable = false;
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'increaseQuantity');
        const index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
      if (item.lineErrors.errors.length > 0) {
        this.errorMsgs.push(item.lineErrors);
        this.getCommonErrors(this.errorMsgs);
      }
    }
  }

  // validation on Save Draft
  validateJDEOrder() {
    let isValidated = true;
    if (this.productAllDataSource.data && this.productAllDataSource.data.length > 0) {
      isValidated = true;
      this.productAllDataSource.data.forEach(x => {
        if (x.lineStatus != 'REJECTED') {
          x = this.validateJDEItem(x);
          x = this.validateLineItem(x);
          if (x.lineErrors.errors.length > 0) {
            this.errorMsgs.push(x.lineErrors);
            this.getCommonErrors(this.errorMsgs);
            isValidated = false;
          }
        } else {
          x.lineErrors.errors = [];
        }
      });
    }
    return isValidated;
  }

  // validation on Save Draft
  validateOrder() {
    let isValidated = true;
    if (this.productAllDataSource.data && this.productAllDataSource.data.length > 0) {
      isValidated = true;
      this.productAllDataSource.data.forEach(x => {
        if (x.lineStatus !== 'REJECTED') {
          x = this.validateLineItem(x);
          if (x.lineErrors.errors.length > 0) {
            this.errorMsgs.push(x.lineErrors);
            this.getCommonErrors(this.errorMsgs);
            isValidated = false;
          }
        } else {
          x.lineErrors.errors = [];
        }
      });
    }
    return isValidated;
  }

  validateJDEItem(item: any) {
    if (item.lineStatus === 'APPROVED' && parseInt(item.returnQuantity) === 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'JDEQuantity');
      item.lineErrors.errors.push({ id: 'JDEQuantity', error: 'Please do one of the following actions: increase the quantity or reject the line' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'JDEQuantity');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (item.lineStatus === 'PENDING') {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'JDEPendingStatus');
      item.lineErrors.errors.push({ id: 'JDEPendingStatus', error: 'Line is pending.  Please approve or reject it.' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'JDEPendingStatus');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (!item.lineStatus || item.lineStatus == '') {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'JDENoLineStatus');
      item.lineErrors.errors.push({ id: 'JDENoLineStatus', error: 'All lines must be  marked as approved or rejected to proceed with the credit.' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'JDENoLineStatus');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    return item;
  }

  checkAnyValidLineItem() {
    const errorCount = this.productAllDataSource.data.filter(x => x.lineErrors.errors.length > 0).length;
    return (errorCount != this.productAllDataSource.data.length ? true : false);
  }

  // Line item validation
  validateLineItem(item: any) {
    // Stocking Type - Scenario Edit/Approval
    if (item.stockingType == 'O') {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'stockingType');
      item.lineErrors.errors.push({ id: 'stockingType', error: 'NonReturnable - Obsolete Product' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'stockingType');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // Treatment - Scenario Edit/Approval
    if (item.treatment !== 'JUT') {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'treatment');
      item.lineErrors.errors.push({ id: 'treatment', error: 'NonReturnable - Treated Product' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'treatment');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // Item Flash msg - Scenario Edit/Approval
    if (item.itemFlashMsgDesc && item.itemFlashMsgDesc.toUpperCase().trim() === 'NONRETURNABLE') {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'itemFlashMsgDesc');
      item.lineErrors.errors.push({ id: 'itemFlashMsgDesc', error: 'This product is non returnable' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'itemFlashMsgDesc');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // Product line - Scenario Edit/Approval
    if (item.productLine !== '4J1' && item.productLine !== 'SOYBEANS') {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'productLine');
      item.lineErrors.errors.push({ id: 'productLine', error: 'The product is not having product line of soybeans' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'productLine');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // Marketing brand - Scenario Edit/Approval
    if (item.marketingBrand && (item.marketingBrand !== 'CROPLAN' && item.marketingBrand !== 'ARMOR')) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'marketingBrand');
      item.lineErrors.errors.push({
        id: 'marketingBrand', error: 'The item must be under the Armor or Croplan marketing brands'
      });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'marketingBrand');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    const productCategory = ['3B2', '3PA', '3PC', '3PF', '3PN', '3PV'];
    // Product Category - Scenario Edit/Approval
    if (item.productCategory in productCategory) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'productCategory');
      item.lineErrors.errors.push({ id: 'productCategory', error: 'Product category not eligible for return' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'productCategory');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // Return Quantity should be > 0
    if (parseInt(item.returnQuantity) <= 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'returnQuantityZero');
      item.lineErrors.errors.push({ id: 'returnQuantityZero', error: 'Dumped units cannot be zero' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'returnQuantityZero');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // Return Quantity
    if (!item.isManualLine && parseInt(item.returnQuantity) > parseInt(item.eligibleUnit)) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'returnQuantity');
      item.lineErrors.errors.push({ id: 'returnQuantity', error: 'Dumped units cannot exceed the Eligible Units' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'returnQuantity');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemId && element.lotNumber === item.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // Return Period End Date
    const currentDate = (new Date()).toLocaleDateString('en-US').replace(/\u200E/g, '');
    if (!item.isManualLine && Date.parse(currentDate) > Date.parse((new Date(item.returnPeriodEnd)).toLocaleDateString('en-US').replace(/\u200E/g, '')) && this.roleType != 'INTERNAL') {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'returnPeriodEnd');
      item.lineErrors.errors.push({ id: 'returnPeriodEnd', error: 'Please contact your DSM or Customer Service regarding your Return Request.' });
    }

    // Invoice Date between invoice start date and invoice end date
    const invoiceDate = new Date(item.originalInvoiceDate).toLocaleDateString('en-US').replace(/\u200E/g, '');
    if (!item.isManualLine && Date.parse(invoiceDate) < Date.parse((new Date(item.originalInvoiceStartDate)).toLocaleDateString('en-US').replace(/\u200E/g, '')) ||
      (Date.parse(invoiceDate) > Date.parse((new Date(item.originalInvoiceEndDate)).toLocaleDateString('en-US').replace(/\u200E/g, '')))) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'originalInvoiceDate');
      item.lineErrors.errors.push({ id: 'originalInvoiceDate', error: 'Invoice date not valid.Please contact your DSM or Customer Service regarding your Return Request.' });
    }

    return item;
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.itemId == this.nextErrorId && x.lotNumber == this.nextLotNumber) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].itemId;
      this.nextLotNumber = this.errorMsgs[this.index].lotNumber;
      this.currentErrorRow = this.index + 1;
      $('#returnRequestView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
        $('#returnRequestView').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].itemId;
      this.nextLotNumber = this.errorMsgs[this.index].lotNumber;
      this.currentErrorRow = 1;
      $('#returnRequestView').scrollTop = 0;
      $('#returnRequestView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.originalProductItemsDataSource.length > 0 && this.productAllDataSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.originalProductItemsDataSource.filter(x => x.itemId === element.itemId && x.lotNumber === element.lotNumber)[0];
        oldLineValue.lineErrors = { 'itemId': oldLineValue.itemId, 'lotNumber': oldLineValue.lotNumber, 'errors': [] };;

        // get current object index
        const currentLineIndex = this.productAllDataSource.data.findIndex(x => x.itemId === element.itemId && x.lotNumber === element.lotNumber);

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.productAllDataSource.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          this.productAllDataSource.data = this.productAllDataSource.data;
          const index = this.errorMsgs.findIndex(function (element) {
            return element.itemId === oldLineValue.itemId && element.lotNumber === oldLineValue.lotNumber;
          });
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }
          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.itemId, oldLineValue.lotNumber);
          this.getCommonErrors(this.errorMsgs);
        }
      }
      else {
        // replace whole object
        this.productAllDataSource.data = JSON.parse(JSON.stringify(this.originalProductItemsDataSource));
        this.productAllDataSource.data.forEach(x => {
          x.eligibleUnit = x.isManualLine ? 0 : ((x.invoiceUnits && x.totalReturnUnits) ? (x.invoiceUnits - x.totalReturnUnits) : x.eligibleUnit);
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
        });
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    if (this.errorMsgs.length > 0) {
      this.showTabs = false;
      this.isSearchClicked = true;
      this.editToolKit = false;
      this.isPlaceOrderEnable = true;
      this.isSaveOrderDraftEnable = true;
    }
    this.enablePlaceOrderAndSaveOrderDraft();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true, labelNo: this.leaveWithoutSavingNoButtonText, inEdit: this.requestStatus === 'IN EDIT' });
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
    this.checkBoxCount = 0;
    this.showTabs = false;
    this.isSearchClicked = true;
    this.editToolKit = false;
    this.isAllProductChecked = false;
  }

  // Hide and show error line error
  showHideLineError(errorId: number, lotNumber: string) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString() + '_' + lotNumber);
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Dealer unit change and validation
  unitChange(action: string, productItem: any) {
    productItem.lineErrors.errors = [];
    const index = this.errorMsgs.findIndex(function (element) {
      return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
    });
    if (index !== -1) {
      this.errorMsgs.splice(index, 1);
    }
    if (action == 'decrease') {
      const decValue = + parseInt(productItem.returnQuantity) - 1;
      if (decValue > 0) {
        productItem.returnQuantity = decValue;
        if (productItem.lineStatus === 'APPROVED') {
          this.validateApprovalQty(productItem);
        }
      }
      else {
        productItem.returnQuantity = 0;
        if (decValue < 0) {
          this.toastrService.error('Dumped units cannot be negative.');
        }
        if (productItem.lineStatus === 'APPROVED') {
          this.validateApprovalQty(productItem);
        }
      }
      productItem = this.validateQty(productItem);
    }
    else {
      productItem.returnQuantity = +productItem.returnQuantity + 1;
      if (productItem.lineStatus === 'APPROVED') {
        this.validateApprovalQty(productItem);
      }
      productItem = this.validateQty(productItem);
    }

    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.originalProductItemsDataSource)).filter(x => x.itemId == productItem.itemId && x.lotNumber == productItem.lotNumber)[0];
    this.setCount();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldReturnQty: oldProductLineValue.returnQuantity, newReturnQty: productItem.returnQuantity, labelNo: this.leaveWithoutSavingNoButtonText, inEdit: this.requestStatus === 'IN EDIT', labelYes: this.leaveWithoutSavingYesButtonText });

    if (!this.isApprovalAccess && this.isEditMode && this.requestStatus == 'PENDING') {
      this.isAddProductEnable = false;
    }
    else {
      this.isAddProductEnable = true;   // Enable Add Product Button
    }

    this.enablePlaceOrderAndSaveOrderDraft();
  }

  validateQty(productItem) {
    if (productItem.returnQuantity === '') {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnEmptyQuantity');
      productItem.lineErrors.errors.push({ id: 'returnEmptyQuantity', error: 'Dumped units cannot be blank' });
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnEmptyQuantity');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }
    // Return Quantity
    if (!productItem.isManualLine && productItem.returnQuantity > productItem.eligibleUnit) {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnQuantity');
      productItem.lineErrors.errors.push({ id: 'returnQuantity', error: 'Dumped units cannot exceed the Eligible Units' });
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnQuantity');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }
    if (productItem.lineErrors.errors.length > 0) {
      this.errorMsgs.push(productItem.lineErrors);
      this.getCommonErrors(this.errorMsgs);
    }
    return productItem;
  }

  // Qty change on text change
  quantityTextChange(productItem) {
    productItem.lineErrors.errors = [];
    const index = this.errorMsgs.findIndex(function (element) {
      return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
    });
    if (index !== -1) {
      this.errorMsgs.splice(index, 1);
    }

    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.originalProductItemsDataSource)).filter(x => x.itemId == productItem.itemId && x.lotNumber == productItem.lotNumber)[0];
    this.setCount();

    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldReturnQty: oldProductLineValue.returnQuantity, newReturnQty: productItem.returnQuantity, labelNo: this.leaveWithoutSavingNoButtonText, inEdit: this.requestStatus === 'IN EDIT' });
    this.validateApprovalQty(productItem);
    productItem = this.validateQty(productItem);
    if (!this.isApprovalAccess && this.isEditMode && this.requestStatus == 'PENDING') {
      this.isAddProductEnable = false;
    }
    else {
      this.isAddProductEnable = true;
    }
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  hasNotesChanged(textInput: string) {
    if (textInput && textInput.length > 0) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { seedReturnValue: true, labelNo: this.leaveWithoutSavingNoButtonText, inEdit: this.requestStatus === 'IN EDIT' });
    }
    if (textInput && textInput.length >= 250) {
      this.toastrService.error('The maximum number of characters has been been reached.');
    }
  }

  setCount() {
    this.filteredDataCount = 0;
    this.qtyCount = 0;
    this.totalPrice = 0;
    this.filteredDataCount = this.productAllDataSource.data.length;
  }

  // Validate the email address entered
  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
    if (this.isNotValid) {
      this.isSaveOrderDraftEnable = false;
      this.isPlaceOrderEnable = false;
    }
    else {
      this.isSaveOrderDraftEnable = true;
      this.isPlaceOrderEnable = true;
      this.enablePlaceOrderAndSaveOrderDraft();
    }
  }

  getAccountList() {
    this.subscription.add(this.seedReturnService.getAccountList().subscribe((result: any[]) => {
      this.shipToAccountItems = result;
      this.shipToDataLoading = false;
      if (this.shipToAccount) {
        const accountItem = this.shipToAccountItems.filter(x => x.accountNumber === this.shipToAccount);
        if (accountItem && accountItem.length > 0) {
          this.selectedAccountName = accountItem[0].accountName;
          this.shipToAccountName = accountItem[0].accountName;
        }
      }
      // this.loaderService.setLoaderStatus(false);
    }, ((error) => {
      this.loaderService.setLoaderStatus(false);
      this.shipToDataLoading = false;
    })));
  }

  checkAutoApproval(accountNumber : any) {
    this.subscription.add(this.seedReturnService.checkAutoApprove(accountNumber).subscribe((result: any) => {
      this.isAutoApprove = result;
      if (this.isAutoApprove) {
        this.isAutoApprove = this.checkReturnPeriodApprovalAccess(MasterConstants.PRODUCT_LINE_SOYBEAN_CODE);
      }
    }, ((error) => {
      this.loaderService.setLoaderStatus(false);
      this.shipToDataLoading = false;
    })));
  }

  // On page destroy
  ngOnDestroy() {
    this.seedReturnService.setReturnRequestId(0);
    this.seedReturnService.setSelectedProductLine('');

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  isValidApproveReject(productLine, marketingBrandId, element = null): boolean {
    if (this.requestStatus && this.requestStatus != 'DRAFT' && this.requestStatus != 'IN EDIT') {
      let isAccess = false;
      if (this.seedReturnService.returnPeriodSecurityList == undefined) {
        this.subscription.add(this.seedReturnService.getReturnPeriodSecurity().subscribe((result: any[]) => {
          this.seedReturnService.setReturnPeriodSecurityList(result);
          isAccess = this.checkApprovalAccess(productLine, marketingBrandId);
        }));
      } else { isAccess = this.checkApprovalAccess(productLine, marketingBrandId); }

      return isAccess;
    } else if (this.requestStatus == 'IN EDIT' && element != null) {
      return element.lineStatus != 'APPROVED';
    }
    return true;
  }

  checkApprovalAccess(productLine, marketingBrandId): boolean {
    const isAccess = this.seedReturnService.returnPeriodSecurityList.find(x => (x.isActivateApprovalPeriod || x.isActivateExceptionPeriod)
      && x.productLineID == productLine
      && x.marketingBrandID == marketingBrandId) == null ? false : true;
    return isAccess;
  }

  checkReturnPeriodApprovalAccess(productLine): boolean {
    const isAccess = this.seedReturnService.returnPeriodSecurityList.find(x => (x.isActivateApprovalPeriod || x.isActivateExceptionPeriod)
      && x.productLineID == productLine) == null ? false : true;
    return isAccess;
  }

  isShowEditButton() {
    if (this.requestStatus && this.requestStatus == 'PENDING') {
      let isAccess = false;
      if (this.seedReturnService.returnPeriodSecurityList == undefined) {
        this.subscription.add(this.seedReturnService.getReturnPeriodSecurity().subscribe((result: any[]) => {
          this.seedReturnService.setReturnPeriodSecurityList(result);
          isAccess = this.seedReturnService.returnPeriodSecurityList.find(x => x.isActivateEntryPeriod || x.isActivateExceptionPeriod) != null ? true : false;
        }));
      } else { isAccess = this.seedReturnService.returnPeriodSecurityList.find(x => x.isActivateEntryPeriod || x.isActivateExceptionPeriod) != null ? true : false; }

      return isAccess;
    }
    return false;
  }

  checkAddProductEnable() {
    let isAccess = false;
    if (this.seedReturnService.returnPeriodSecurityList == undefined) {
      this.subscription.add(this.seedReturnService.getReturnPeriodSecurity().subscribe((result: any[]) => {
        this.seedReturnService.setReturnPeriodSecurityList(result);
        isAccess = this.seedReturnService.returnPeriodSecurityList.find(x => x.isActivateEntryPeriod || x.isActivateExceptionPeriod) != null ? true : false;
      }));
    } else {
      isAccess = this.seedReturnService.returnPeriodSecurityList.find(x => x.isActivateEntryPeriod || x.isActivateExceptionPeriod) != null ? true : false;
    }
    return isAccess;
  }

  OnEditClick(status) {
    this.loaderService.setLoaderStatus(true);
    const postData = {
      returnRequestId: this.returnRequestId,
      ReturnRequestType: 'SOYBEAN',
      ReturnRequestStatus: status
    };
    if (this.requestStatus === 'PENDING') {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldReturnQty: 1, newReturnQty: 0, labelNo: this.leaveWithoutSavingNoButtonText, inEdit: this.requestStatus === 'PENDING', labelYes: this.leaveWithoutSavingYesButtonText });
    }
    this.subscription.add(this.seedReturnService.updateReturnRequestHeader(postData).subscribe((result: any) => {
      if (result) {
        if (result.success) {
          this.requestStatus = 'IN EDIT';
          this.isRequestPending = false;
          this.isEditMode = true;
          this.breadcrumbtext = 'Edit Return Request [' + this.returnRequestNumber + ']';
          this.leaveWithoutSavingYesButtonText = 'Discard changes and submit request';
          this.enableFiltersAndButtonAsPermission();

          const blnAddProductPermission = this.checkAddProductEnable();
          if (this.requestStatus == 'IN EDIT' && blnAddProductPermission) {
            this.reviewRequestMode = false;
            this.isAddProductEnable = true;
          }

          if (this.productAllDataSource && this.productAllDataSource.length > 0) {
            this.productAllDataSource.forEach(x => {
              x.isSelected = false;
              if ((x.lineStatus == 'PENDING' || x.lineStatus == 'APPROVED') && !blnAddProductPermission) {
                x.isIncreaseQtyDisable = true;
                x.isDecreaseQtyDisable = true;
              }
              else {
                x.isIncreaseQtyDisable = false;
                x.isDecreaseQtyDisable = false;
              }
            });
          }
          this.toastrService.success('Return Request Status updated.');
          this.loaderService.setLoaderStatus(false);
        } else {
          this.loaderService.setLoaderStatus(false);
          this.toastrService.error('Return Request Status not updated in the system.');
        }
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Return Request Status not updated in the system.');
    }));
  }

  isDisableSubmitForCreditBtn(): boolean {
    return this.isRequestPending || this.isNotValid || this.productAllDataSource.filteredData.length <= 0 ||
      this.productAllDataSource.filteredData.filter(x => x.lineStatus !== 'APPROVED' && x.lineStatus !== 'REJECTED').length > 0;
  }

  submitForCreditAutoApproval() {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');

    const isValidated = true;

    
    this.isPlaceOrderEnable = false;
    let productList: any;
    productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
    const newLineItems = [];
    this.productAllDataSource.data.filter(x => {
      x.lineStatus = "APPROVED";
    });

    productList.filter(x => {
      if (x.lineStatus === '' || x.lineStatus === null || x.lineStatus === 'DRAFT') {
        newLineItems.push(JSON.parse(JSON.stringify(x)));
      }
      x.lineStatus = "APPROVED";
      x.errorMessage = null;
    });

    const item = this.requestOnBehalfList.filter(r => r.userId == this.requestedByUser)[0];
    if (this.requestedByUser && item) {
      this.selectedUserName = item.userName;
    }

    if (this.validateJDEOrder()) {
      this.loaderService.setLoaderStatus(true);
      const postData = {
        returnRequestId: this.returnRequestId,
        ReturnRequestType: 'SOYBEAN',
        ReturnRequestStatus: 'PENDING',
        CompanyCode: this.headerCompany,
        IsUpdateRequest: this.seedReturnService.getEditModeStatus(),
        ShipToAccountId: this.shipToAccount,
        DsmId: this.dsmId,
        BranchPlant: null,
        SeedReturnProductList: productList,
        ScaleTicketList: this.scaleTicketList,
        Email:  this.accountEmail,
        EmailUserName: this.selectedUserName,
        Requestedby: this.requestedByUser,
        ProductLine: MasterConstants.PRODUCT_LINE_SOYBEAN_CODE
      };

      this.subscription.add(this.seedReturnService.submitForCreditAutoRequest(postData).subscribe((result: any) => {
        if (result) {
          const errorCount = result.seedReturnProductList.filter(x => x.errorMessage != null).length;
          if (errorCount > 0) {
            this.productAllDataSource.data = result.seedReturnProductList;
            this.productAllDataSource.data.forEach(x => {
              const item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
              if (item.length > 0) {
                x.lineStatus = item[0].lineStatus;
              }
              if (x.errorMessage != '' && x.errorMessage != null) {
                x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [{ 'error': x.errorMessage }] };
                this.errorMsgs.push(x.lineErrors);
              }
              else {
                x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
              }
            });
            this.getCommonErrors(this.errorMsgs);
            this.loaderService.setLoaderStatus(false);
          } else {
            this.toastrService.success('Return Request submitted successfully.');
            this.seedReturnService.webOrderNumberAndSplitId = result.jdeOrderNumber + '-' + 0 + '- ' + '-SeedReturn';// Done '- ' so that we could show non errored data
            this.router.navigate(['/seed-returns-soybean-dashboard']);

            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });

            this.loaderService.setLoaderStatus(false);
          }
        }
      }, error => {
        this.isPlaceOrderEnable = true;
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Return Request not saved in the system.');
      }));
    } else {
      this.isPlaceOrderEnable = false;
    }
  }
}
